import {ref} from 'vue';
import {systemInfo} from "@/systemInfo.js";

// Map to keys from systemInfo
const appParams = {
    SN: 'serialNumber',
    handshake: 'handshakeInfo',
    login: 'login.data',
    PD: 'prizeData.data',
    PE: 'prizeEnabled',
    env: 'env'
}
const env = import.meta.env.VITE_ENVIRONMENT

// Default icon to use when app icon is not found
export const defaultIcon = 'default.webp';

//Default app to use when user defined default app cannot be found or is disabled
export const fallbackApp = ref({
    name: 'trivia',
    label: 'Trivia',
    status: env
})
export const apps = ref([])
export const internalApps = ref([])
export const betaApps = ref([])

export const initializeApps = () => {
    if (systemInfo.apps) {
        apps.value = systemInfo.apps;
    }
    if (systemInfo.internalApps) {
        internalApps.value = systemInfo.internalApps;
    }
    if (systemInfo.betaApps) {
        betaApps.value = systemInfo.betaApps;
    }
};

export const initializeDefaultApp = () => {

    if (!systemInfo.apps) {
        console.warn("No apps loaded")
        return;
    }

    if (!systemInfo.defaultApp || !systemInfo.defaultApp.name) {
        console.warn("No default app provided by API, using fallback");
        systemInfo.defaultApp = fallbackApp
        return;
    }

    const defaultApp =
        systemInfo.apps?.find(app => app.name === systemInfo.defaultApp.name) ||
        systemInfo.internalApps?.find(app => app.name === systemInfo.defaultApp.name) ||
        systemInfo.betaApps?.find(app => app.name === systemInfo.defaultApp.name);

    if (defaultApp && (!defaultApp.disabled || defaultApp.disabled === false)) {
        console.log(`Setting default app from API: ${defaultApp.label} ${defaultApp.status} (${defaultApp.name})`);

        // Clear any existing default flags
        systemInfo.apps.forEach(app => {
            app.is_default = false;
        });

        // Set the API-provided app as default
        defaultApp.is_default = true;

        return true;
    } else {
        console.warn(`Default app ${systemInfo.defaultApp.name} not found or disabled, using fallback`);
        systemInfo.defaultApp = fallbackApp
        initializeDefaultApp()
        // return false;
    }
}

// Make apps available globally for keyboard navigation
window.appsRef = apps;

// Add IDs to apps if they don't have them
export const ensureAppIds = () => {
    let nextId = 1;
    console.log("ENSURING APP IDS", apps);

    // Process regular apps
    apps.value.forEach(app => {
        if (!app.id) {
            app.id = nextId++;
        }
    });

    // Process internal apps if they exist
    if (internalApps.value) {
        internalApps.value.forEach(app => {
            if (!app.id) {
                app.id = nextId++;
            }
        });
    }

    // Process beta apps if they exist
    if (betaApps.value) {
        betaApps.value.forEach(app => {
            if (!app.id) {
                app.id = nextId++;
            }
        });
    }
};

export const processApps = (fetchedApps) => {
    // Use API schema directly, just add computed field
    const processedApps = fetchedApps.map(app => ({
        ...app,
        id: app.sort_order,
    }));

    systemInfo.apps = processedApps.filter(app => app.status === 'PRD');
    systemInfo.internalApps = processedApps.filter(app => app.status !== 'PRD' && app.status !== 'BETA');
    systemInfo.betaApps = processedApps.filter(app => app.status === 'BETA');
}

export const fallbackDefaultApp =
        {
            id: null,
            name: "trivia",
            label: "Trivia",
            app_url: "https://ntnservices.buzztime.com",
            spectator_url: "https://ntnservices.buzztime.com/app/spectator/",
            icon_url: "trivia.webp",
            game_id_type: null,
            disabled: false,
            params: false,
            is_default: true,
            status: "PRD",
            sort_order: 1
        }

export const fallbackAppsList = [
    {
        id: null,
        name: "bets",
        label: "Bets",
        app_url: "https://bets.opengamingsolutions.com",
        spectator_url: "https://bets-spectator.buzztime.com/?view=boxscore-carousel,dfs-leaderboard&interval=10&site_id=&gameIds=",
        icon_url: "bets.webp",
        game_id_type: "All",
        disabled: true,
        params: false,
        is_default: false,
        status: "PRD",
        sort_order: 1
    },
    {
        id: null,
        name: "bingo",
        label: "Bingo",
        app_url: "https://bingo.buzztime.com",
        spectator_url: "https://bingo.buzztime.com/spectator/?RoomId=",
        icon_url: "bingo.webp",
        game_id_type: "Room ID",
        disabled: false,
        params: false,
        is_default: false,
        status: "PRD",
        sort_order: 2
    },
    {
        id: null,
        name: "live-trivia",
        label: "Live Trivia",
        app_url: "https://livetrivia.buzztime.com",
        spectator_url: "https://livetrivia.buzztime.com/spectator/?RoomId=",
        icon_url: "live-trivia.webp",
        game_id_type: "Game ID",
        disabled: false,
        params: false,
        is_default: false,
        status: "PRD",
        sort_order: 3
    },
    {
        id: null,
        name: "poker",
        label: "Poker",
        app_url: "https://poker.buzztime.com",
        spectator_url: "https://poker.buzztime.com/poker-spectator.php?gameID=",
        icon_url: "poker.webp",
        game_id_type: "Table ID",
        disabled: false,
        params: false,
        is_default: false,
        status: "PRD",
        sort_order: 4
    },
    {
        id: null,
        name: "trivia",
        label: "Trivia",
        app_url: "https://ntnservices.buzztime.com",
        spectator_url: "https://ntnservices.buzztime.com/app/spectator/",
        icon_url: "trivia.webp",
        game_id_type: null,
        disabled: false,
        params: false,
        is_default: true,
        status: "PRD",
        sort_order: 5
    }
]